export interface TaxiUser {
  firstName: string;
  lastName: string;
  email: string;
}

export function getCookie(name: string): string {
  if (typeof window !== "undefined") {
    if (window?.document?.cookie) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);

      if (parts?.length === 2) {
        return parts?.pop()?.split(";")[0] || "";
      }
    }
  }

  return "";
}

export function getTaxiUserInfo(): TaxiUser | null {
  if (typeof window === "undefined" || !window?.document?.cookie) {
    return null;
  }

  const cookieString = `; ${document.cookie}`;

  const extractValue = (name: string): string => {
    const parts = cookieString.split(`; ${name}=`);
    return parts.length === 2 ? parts.pop()?.split(";")[0] || "" : "";
  };

  const firstName = extractValue("taxi-first_name");
  const lastName = extractValue("taxi-last_name");
  const email = extractValue("taxi-email");

  if (!firstName && !lastName && !email) {
    return null;
  }

  return {
    firstName,
    lastName,
    email,
  };
}
